import React from "react";
import SEO from "../../../../shared/components/SEO";
import { ArticleSection, CollectionCover, SearchBar } from "../../../../shared";

/**
 *
 * @param {Object} props
 * @param {Object} props.seo             spread onto `<SEO />`
 * @param {Object} props.cover           spread onto `<CollectionCover />`
 * @param {Object} props.article         spread onto `<ArticleSection />`
 * @param {string} props.searchPlaceholder
 */
const CollectionIntro = ({ seo, cover, article, searchPlaceholder }) => (
  <>
    <SEO {...seo} />
    <CollectionCover {...cover} />
    <ArticleSection {...article} />
    <SearchBar placeholder={searchPlaceholder} />
  </>
);

export default CollectionIntro;
